import React from 'react';
import ReserveStoreCard from '../ReserveStoreCard';
import DateTimeSelector from '../DateTimeSelector';
import EmptyPlaceHolder from '../../components/EmptyPlaceHolder';
import './index.scss';

export default function ReserveByStorePanel(props) {
  const { storeContent, dateContent, onDateTimeChange, reserveItems } = props;
  return (
    <React.Fragment>
      <ReserveStoreCard
        storeContent={storeContent}
        reserveItems={reserveItems}
      />
      {
        !!storeContent?.groupFive && (
          <div className="dates-empty-field">
            <EmptyPlaceHolder />
          </div>
        )
      }
      {
        dateContent && dateContent.length > 0 && !storeContent?.groupFive && (
          <DateTimeSelector
            dates={dateContent}
            onDateTimeChange={onDateTimeChange}
          />
        )
      }
    </React.Fragment>
  )
}